module.exports = __webpack_public_path__ + "static/media/pizza-image-3.24d95934.png";